import { Link } from 'gatsby';
import React from 'react';

function Cta({ title, linkUrl, linkText }) {
  return (
    <section className="my-20 md:my-28 mt-36">
      <div className="container text-center flex flex-col items-center max-w-[960px]">
        <h2 className="text-secondary-h2">{title}</h2>
        <div className="mt-12">
          <Link to={linkUrl} className={`c-btn c-btn--primary c-btn--no-icon`}>
            {linkText}
          </Link>
        </div>
      </div>
    </section>
  );
}

export default Cta;
